import { checkCookie, setCookie } from '../../utils/cookie.js';

export default class GenerateData {
  async #setDataToCookie(name, data) {
    const generatedData = this.#generate(data);
    const stringifiedData = JSON.stringify(generatedData);
    await setCookie(name, stringifiedData, 1);
  }

  #generate({ ...o }) {
    for (const key in o) {
      if (typeof o[key] === 'object') o[key] = this.#generate(o[key]);
    }

    if (
      Object.prototype.hasOwnProperty.call(o, 'max') &&
      Object.prototype.hasOwnProperty.call(o, 'min')
    ) {
      o.data = this.#randomIntFromInterval(o.min, o.max);
      delete o.max;
      delete o.min;
    }
    if (
      Object.prototype.hasOwnProperty.call(o, 'rangeMin') &&
      Object.prototype.hasOwnProperty.call(o, 'rangeMax') &&
      Object.prototype.hasOwnProperty.call(o, 'length')
    ) {
      o.chartData = this.#randomIntArrayInRange(o.rangeMin, o.rangeMax, o.length);
      delete o.rangeMin;
      delete o.rangeMax;
    }

    return o;
  }

  #randomIntFromInterval(min, max) {
    const array = new Uint32Array(1);
    crypto.getRandomValues(array);
    const randomValue = array[0] / (0xff_ff_ff_ff + 1);

    return Math.floor(randomValue * (max - min + 1) + min).toLocaleString();
  }

  #randomIntArrayInRange(min, max, n = 1) {
    const array = new Uint32Array(1);
    crypto.getRandomValues(array);
    const randomValue = array[0] / (0xff_ff_ff_ff + 1);

    return Array.from({ length: n }, () => Math.floor(randomValue * (max - min + 1)) + min);
  }

  async generateData(name, data) {
    const hasCookie = checkCookie(name);
    if (!hasCookie) {
      await this.#setDataToCookie(name, data);
    }
  }
}
